/**
 * Product FAQ Section JavaScript
 * Handles accordion functionality and FAQ interactions.
 */
(function () {
  function setItemState(item, open) {
    item.classList.toggle('active', open);
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    if (question) question.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (answer) answer.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function initProductFaq(root) {
    const scope = root || document;
    scope.querySelectorAll('.product-faq-section .faq-item').forEach((item) => {
      const question = item.querySelector('.faq-question');
      if (!question || question.dataset.productFaqBound === 'true') return;

      question.dataset.productFaqBound = 'true';
      question.setAttribute('role', 'button');
      question.setAttribute('tabindex', '0');
      question.setAttribute('aria-expanded', item.classList.contains('active') ? 'true' : 'false');

      const answer = item.querySelector('.faq-answer');
      if (answer) answer.setAttribute('aria-hidden', item.classList.contains('active') ? 'false' : 'true');

      const toggle = () => {
        const section = item.closest('.product-faq-section');
        const accordionMode = section && section.dataset.accordionMode === 'true';
        const shouldOpen = !item.classList.contains('active');

        if (accordionMode && shouldOpen && section) {
          section.querySelectorAll('.faq-item.active').forEach((otherItem) => {
            if (otherItem !== item) setItemState(otherItem, false);
          });
        }

        setItemState(item, shouldOpen);
      };

      question.addEventListener('click', toggle);
      question.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });
    });
  }

  window.ElixirProductFaqInit = initProductFaq;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductFaq(document));
  } else {
    initProductFaq(document);
  }

  document.addEventListener('shopify:section:load', (event) => initProductFaq(event.target));
})();
